'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames3 = require('classnames');

var _classnames4 = _interopRequireDefault(_classnames3);

var _Span = require('../Span');

var _Span2 = _interopRequireDefault(_Span);

var _P = require('../P');

var _P2 = _interopRequireDefault(_P);

var _SpacerElement = require('../../internal/SpacerElement');

var _SpacerElement2 = _interopRequireDefault(_SpacerElement);

var _UnstyledButton = require('../UnstyledButton');

var _UnstyledButton2 = _interopRequireDefault(_UnstyledButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = {
  'wrapper': 'ccl-1aa46f2e5c0e8f0e',
  'wrapperReverseRow': 'ccl-389783a4ebe05930',
  'wrapperVerticalAlignCenter': 'ccl-1cb83a1a40889f7f',
  'left': 'ccl-5e10e3098742e50d',
  'main': 'ccl-329f91fe3811b3d9',
  'right': 'ccl-115b2fb253c504a9',
  'placeholder': 'ccl-1c12455cb72dac33'
};


function pickContent(content) {
  if (typeof content === 'string' && Boolean(content)) {
    return _react2.default.createElement(
      _Span2.default,
      null,
      content
    );
  }
  return content;
}

function pickSecondaryContent(content) {
  var defaultProps = { color: 'grey', size: 'small' };

  if (typeof content === 'string' && Boolean(content)) {
    return _react2.default.createElement(
      _Span2.default,
      defaultProps,
      content
    );
  }

  // allow render prop to pass default color and size if wanted
  if (typeof content === 'function') {
    return content(defaultProps);
  }

  return content;
}

function pickMainContent(children) {
  if (typeof children === 'string' && Boolean(children)) {
    return _react2.default.createElement(
      _P2.default,
      null,
      children
    );
  }

  return children;
}

var Row = function Row(_ref) {
  var _classnames;

  var adjacentHorizontalSpacing = _ref.adjacentHorizontalSpacing,
      adjacentVerticalSpacing = _ref.adjacentVerticalSpacing,
      children = _ref.children,
      isPlaceholder = _ref.isPlaceholder,
      isReversedOnMobile = _ref.isReversedOnMobile,
      left = _ref.left,
      onClick = _ref.onClick,
      placeholderClassName = _ref.placeholderClassName,
      right = _ref.right,
      secondary = _ref.secondary,
      spacing = _ref.spacing,
      verticalAlign = _ref.verticalAlign;

  var contentLeft = pickContent(left);
  var contentRight = pickContent(right);
  var contentSubtitle = pickSecondaryContent(secondary);
  var contentMain = pickMainContent(children);

  var wrapperClasses = (0, _classnames4.default)(styles.wrapper, (_classnames = {}, _defineProperty(_classnames, styles.wrapperVerticalAlignCenter, verticalAlign === 'center'), _defineProperty(_classnames, styles.wrapperReverseRow, isReversedOnMobile), _classnames));

  var placeholderClasses = (0, _classnames4.default)(styles.placeholder, _defineProperty({}, placeholderClassName, isPlaceholder));

  var rowContent = _react2.default.createElement(
    'div',
    { className: wrapperClasses },
    contentLeft && _react2.default.createElement(
      'div',
      { className: styles.left },
      contentLeft
    ),
    _react2.default.createElement(
      'div',
      { className: styles.main },
      contentMain,
      contentSubtitle
    ),
    contentRight && _react2.default.createElement(
      'div',
      { className: styles.right },
      contentRight
    )
  );

  if (typeof onClick === 'function') {
    rowContent = _react2.default.createElement(
      _UnstyledButton2.default,
      { isBlock: true, onClick: onClick },
      rowContent
    );
  }

  return _react2.default.createElement(
    _SpacerElement2.default,
    {
      element: 'div',
      spacing: spacing,
      isPlaceholder: isPlaceholder,
      placeholderClassName: placeholderClasses,
      adjacentVerticalSpacing: adjacentVerticalSpacing,
      adjacentHorizontalSpacing: adjacentHorizontalSpacing
    },
    rowContent
  );
};

Row.displayName = 'Row';
Row.propTypes = _extends({
  /**
   * The content to be rendered in the main section. If plain text, it will styled as text. If it's a node, it will be
   * inserted as passed. See examples.
   */
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]).isRequired,

  /**
   * Will reverse the row content on mobile devices. This is useful for things like radio/checkbox/switch inputs where
   * the input switches sides depending on whether or not we match the tablet viewport
   */
  isReversedOnMobile: _propTypes2.default.bool,

  /**
   * The content to be rendered in the left section. If plain text, it will styled as text. If it's a node, it will be
   * inserted as passed. See examples.
   */
  left: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),

  /**
   * The function that is called Row is clicked on
   */
  onClick: _propTypes2.default.func,

  /**
   * The content to be rendered in the right section. If plain text, it will styled as text. If it's a node, it will be
   * inserted as passed. See examples.
   */
  right: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),

  /**
   * The content to be rendered underneath the main content (`children` prop). If plain text, it will styled as text.
   * If it's a node, it will be inserted as passed. If it's a function, the function will be passed an object with `size`
   * and `color` as properties and will render the returned content. See examples.
   */
  secondary: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string, _propTypes2.default.func]),

  /**
   * Determines if the content inside the row is vertically aligned to the top or center of the Row
   */
  verticalAlign: _propTypes2.default.oneOf(['top', 'center'])

}, _SpacerElement2.default.propTypes);

Row.defaultProps = {
  isReversedOnMobile: false,
  left: undefined,
  onClick: undefined,
  right: undefined,
  secondary: undefined,
  verticalAlign: 'center'
};

exports.default = Row;